import React from 'react';

import { SvgIcon } from '@mui/material';
import classNames from 'classnames';

import { useStyles } from '../Icon.styles';
import { LegacyIconProps } from '../Icon.types';

export const Poo = ({
  size = 'default',
  color = 'secondary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7957 7.93273C13.7958 7.93265 13.7959 7.93257 13.7959 7.93249L13.7959 7.9327C13.7959 7.9327 13.7959 7.93271 13.7957 7.93273ZM6.37703 7.95564C6.37682 7.95553 6.37662 7.95543 6.37641 7.95532C5.45961 7.25666 5.89789 5.58502 6.95844 4.95356C7.30837 4.74516 7.70535 4.60503 8.08836 4.46983C8.59165 4.29218 9.07081 4.12305 9.38734 3.81871C9.66082 3.55574 9.80191 3.3172 9.91984 3.11783C10.0697 2.86441 10.1822 2.67429 10.4815 2.57777C11.2385 2.33389 12.1534 3.62428 11.8967 4.87283C13.2369 4.5829 14.6821 6.28521 13.7961 7.93268C15.2069 7.64753 16.3595 9.47866 15.3703 11.0019C17.0288 11.2149 17.7881 12.6904 17.5221 14.2766C17.1721 16.3637 14.0494 17.4521 9.85023 17.4521C5.65101 17.4521 2.85491 16.447 2.39046 14.3789C2.01118 12.6909 2.91969 11.5264 4.52427 11.3746C3.5754 10.1062 4.8683 7.88072 6.37641 7.95553C6.37662 7.95557 6.37683 7.9556 6.37703 7.95564ZM15.3701 11.0023L15.37 11.0023L15.3701 11.0021V11.0023Z"
        fill="#AD4719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7569 7.93892C13.7587 7.93678 13.7605 7.93464 13.7622 7.93249V7.93292C14.6485 6.28537 13.2032 4.58289 11.863 4.87283C12.1196 3.62428 11.2048 2.33389 10.4478 2.57777C10.1485 2.67429 10.036 2.86441 9.88611 3.11783C9.76819 3.3172 9.6271 3.55574 9.35362 3.81871C9.03708 4.12305 8.55793 4.29218 8.05464 4.46983C7.67163 4.60503 7.27465 4.74516 6.92471 4.95356C5.86477 5.58466 5.42639 7.25475 6.34112 7.95412C4.8494 7.91825 3.58613 10.1172 4.52733 11.3749L4.52763 11.3753L4.52444 11.3746C2.91976 11.5264 2.01116 12.6908 2.39046 14.3789C2.85491 16.447 5.65101 17.4521 9.85023 17.4521C14.0494 17.4521 17.1721 16.3637 17.5221 14.2766C17.788 12.6913 17.0296 11.2165 15.373 11.0022L15.373 11.0021C16.3625 9.47881 15.2098 7.64741 13.7988 7.9327C13.7988 7.9327 13.7845 7.93491 13.7569 7.93892Z"
        fill="url(#paint0_radial_4706_230593)"
      />
      <path
        d="M15.3701 11.0023C16.3596 9.47902 15.2069 7.64762 13.7959 7.93292C14.6823 6.28537 13.2369 4.58289 11.8967 4.87283C12.153 3.62428 11.2381 2.33389 10.4815 2.57777C9.94671 2.75022 10.0084 3.22149 9.38734 3.81871C8.82991 4.35465 7.76819 4.4713 6.95843 4.95356C5.89788 5.58544 5.4596 7.25666 6.3764 7.95532C4.86819 7.88051 3.57523 10.1063 4.52444 11.3747C2.91976 11.5264 2.01116 12.6908 2.39046 14.379C2.85491 16.4471 5.65101 17.4521 9.85023 17.4521C14.0494 17.4521 17.1721 16.3638 17.5221 14.2767C17.7881 12.6904 17.0287 11.2149 15.3701 11.0019V11.0023Z"
        fill="url(#paint1_radial_4706_230593)"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M15.3701 11.0023C16.3596 9.47902 15.2069 7.64762 13.7959 7.93292C14.6823 6.28537 13.2369 4.58289 11.8967 4.87283C12.153 3.62428 11.2381 2.33389 10.4815 2.57777C9.94671 2.75022 10.0084 3.22149 9.38734 3.81871C8.82991 4.35465 7.76819 4.4713 6.95843 4.95356C5.89788 5.58544 5.4596 7.25666 6.3764 7.95532C4.86819 7.88051 3.57523 10.1063 4.52444 11.3747C2.91976 11.5264 2.01116 12.6908 2.39046 14.379C2.85491 16.4471 5.65101 17.4521 9.85023 17.4521C14.0494 17.4521 17.1721 16.3638 17.5221 14.2767C17.7881 12.6904 17.0287 11.2149 15.3701 11.0019V11.0023Z"
          fill="url(#paint2_radial_4706_230593)"
        />
      </g>
      <path
        d="M6.81123 12.5209C5.32766 12.24 4.78835 11.6956 4.54697 11.3887C3.98432 11.3887 3.44338 11.6333 3.09082 11.9185C4.59342 13.019 6.24517 12.5809 6.81123 12.5209Z"
        fill="url(#paint3_radial_4706_230593)"
      />
      <path
        d="M13.1077 12.1244C14.5913 11.8435 15.1322 11.3098 15.3736 11.0029C15.9207 11.0664 16.3887 11.3193 16.7412 11.6044C15.2386 12.7049 13.6738 12.1844 13.1077 12.1244Z"
        fill="url(#paint4_radial_4706_230593)"
      />
      <path
        d="M10.1734 4.66286C10.8728 3.96341 11.9341 4.31565 11.9341 4.31565C11.9341 4.31565 12.0575 5.16113 11.262 5.72729C10.496 6.23415 10.2709 6.21341 9.73344 6.26703C9.60095 6.2434 9.47393 5.3623 10.1734 4.66286Z"
        fill="url(#paint5_radial_4706_230593)"
      />
      <path
        d="M6.04458 10.7253C5.34513 10.0258 4.20575 10.3781 4.20575 10.3781C4.20575 10.3781 4.12804 11.1969 4.95594 11.7897C5.7185 12.2679 5.97553 12.327 6.51392 12.4763C6.59546 12.2411 6.74402 11.4247 6.04458 10.7253Z"
        fill="url(#paint6_radial_4706_230593)"
      />
      <path
        d="M13.8735 10.3289C14.573 9.62947 15.7259 9.97156 15.7259 9.97156C15.7259 9.97156 15.6276 10.9801 14.956 11.4063C14.2274 11.9144 13.8884 11.93 13.4042 12.08C13.3226 11.8448 13.1741 11.0284 13.8735 10.3289Z"
        fill="url(#paint7_radial_4706_230593)"
      />
      <path
        d="M10.0002 6.30873C10.9865 6.02304 11.7522 5.50467 11.9021 4.86345C12.5779 4.73084 13.0776 5.11495 13.248 5.2228C11.6036 6.2412 10.6889 6.38178 10.0002 6.30873Z"
        fill="url(#paint8_radial_4706_230593)"
      />
      <path
        opacity="0.7"
        d="M17.6953 14.375C17.6953 15.9714 14.2762 17.2656 10.0586 17.2656C5.84095 17.2656 2.42188 15.9714 2.42188 14.375C2.42188 12.7786 5.84095 11.4844 10.0586 11.4844C14.2762 11.4844 17.6953 12.7786 17.6953 14.375Z"
        fill="url(#paint9_radial_4706_230593)"
      />
      <path
        d="M10.1563 10.2604C10.2202 9.58365 9.05434 8.92013 7.55236 8.77842C6.05039 8.6367 4.78104 9.07046 4.71718 9.74724C4.65333 10.424 5.81915 11.0875 7.32112 11.2293C8.8231 11.371 10.0925 10.9372 10.1563 10.2604Z"
        fill="url(#paint10_radial_4706_230593)"
      />
      <g filter="url(#filter0_f_4706_230593)">
        <path
          d="M9.99088 6.36394C10.0298 5.95156 9.31926 5.54724 8.40385 5.46087C7.48845 5.3745 6.71483 5.63879 6.67592 6.05117C6.63701 6.46355 7.34755 6.86787 8.26295 6.95424C9.17835 7.04061 9.95198 6.77632 9.99088 6.36394Z"
          fill="url(#paint11_radial_4706_230593)"
        />
      </g>
      <path
        d="M9.40823 9.85492C9.40823 10.8093 8.69686 11.5829 7.81935 11.5829C6.94183 11.5829 6.23047 10.8093 6.23047 9.85492C6.23047 8.90059 6.94183 8.12695 7.81935 8.12695C8.69686 8.12695 9.40823 8.90059 9.40823 9.85492Z"
        fill="url(#paint12_linear_4706_230593)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.81935 8.26367C7.02792 8.26367 6.36719 8.96507 6.36719 9.85492C6.36719 10.7448 7.02792 11.4462 7.81935 11.4462C8.61078 11.4462 9.27151 10.7448 9.27151 9.85492C9.27151 8.96507 8.61078 8.26367 7.81935 8.26367ZM6.09375 9.85492C6.09375 8.83611 6.85575 7.99023 7.81935 7.99023C8.78294 7.99023 9.54495 8.83611 9.54495 9.85492C9.54495 10.8737 8.78294 11.7196 7.81935 11.7196C6.85575 11.7196 6.09375 10.8737 6.09375 9.85492Z"
        fill="url(#paint13_linear_4706_230593)"
      />
      <path
        d="M8.8755 9.96785C8.8755 10.5094 8.47183 10.9484 7.97388 10.9484C7.47593 10.9484 7.07227 10.5094 7.07227 9.96785C7.07227 9.42631 7.47593 8.9873 7.97388 8.9873C8.47183 8.9873 8.8755 9.42631 8.8755 9.96785Z"
        fill="#421D30"
      />
      <path
        d="M10.4707 9.85492C10.4707 10.8093 11.182 11.5829 12.0596 11.5829C12.9371 11.5829 13.6484 10.8093 13.6484 9.85492C13.6484 8.90059 12.9371 8.12695 12.0596 8.12695C11.182 8.12695 10.4707 8.90059 10.4707 9.85492Z"
        fill="url(#paint14_linear_4706_230593)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0596 8.26367C12.851 8.26367 13.5117 8.96507 13.5117 9.85492C13.5117 10.7448 12.851 11.4462 12.0596 11.4462C11.2681 11.4462 10.6074 10.7448 10.6074 9.85492C10.6074 8.96507 11.2681 8.26367 12.0596 8.26367ZM13.7852 9.85492C13.7852 8.83611 13.0232 7.99023 12.0596 7.99023C11.096 7.99023 10.334 8.83611 10.334 9.85492C10.334 10.8737 11.096 11.7196 12.0596 11.7196C13.0232 11.7196 13.7852 10.8737 13.7852 9.85492Z"
        fill="url(#paint15_linear_4706_230593)"
      />
      <path
        d="M11.0034 9.96785C11.0034 10.5094 11.4071 10.9484 11.905 10.9484C12.403 10.9484 12.8066 10.5094 12.8066 9.96785C12.8066 9.42631 12.403 8.9873 11.905 8.9873C11.4071 8.9873 11.0034 9.42631 11.0034 9.96785Z"
        fill="#421D30"
      />
      <path
        d="M7.4025 12.6431C7.19762 12.5687 6.898 12.7646 6.97124 12.9699C7.91484 15.6146 12.2145 15.6159 13.1586 12.9699C13.2318 12.7646 12.9322 12.5687 12.7273 12.6431C11.1077 13.2309 9.02218 13.2309 7.4025 12.6431Z"
        fill="white"
      />
      <path
        d="M7.30527 12.5352C8.92495 13.123 11.2118 13.1426 12.8315 12.5547L13.2625 12.7824C11.5626 13.6528 8.55634 13.6929 6.87988 12.762L7.30527 12.5352Z"
        fill="#C1C1C1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.92358 12.4785C7.0668 12.376 7.28668 12.3093 7.49588 12.3853C9.05529 12.9513 11.0747 12.9513 12.6341 12.3853C12.8433 12.3093 13.0632 12.376 13.2064 12.4785C13.3474 12.5793 13.5113 12.7946 13.4162 13.061C12.8949 14.522 11.457 15.2268 10.0648 15.2266C8.67265 15.2264 7.23483 14.5213 6.71379 13.061C6.61873 12.7946 6.78261 12.5793 6.92358 12.4785ZM6.97133 12.9691C6.89809 12.7639 7.19771 12.5679 7.40259 12.6423C9.02227 13.2302 11.1078 13.2302 12.7274 12.6423C12.9323 12.5679 13.2319 12.7639 13.1587 12.9691C12.2146 15.6152 7.91493 15.6138 6.97133 12.9691Z"
        fill="url(#paint16_linear_4706_230593)"
      />
      <defs>
        <filter
          id="filter0_f_4706_230593"
          x="6.28418"
          y="5.05371"
          width="4.09863"
          height="2.30762"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.195312"
            result="effect1_foregroundBlur_4706_230593"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.93941 9.52847) scale(5.61944 6.06697)"
        >
          <stop stopColor="#CB6431" />
          <stop offset="0.526042" stopColor="#9E370A" />
          <stop offset="1" stopColor="#862807" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.93941 16.5105) scale(10.8297 11.7179)"
        >
          <stop offset="0.517385" stopColor="#C77842" stopOpacity="0" />
          <stop offset="1" stopColor="#FF9D73" stopOpacity="0.5" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.93941 12.0984) scale(7.63473 8.3055)"
        >
          <stop offset="0.517385" stopColor="#C77842" stopOpacity="0" />
          <stop offset="1" stopColor="#923F1C" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.31508 11.7971) rotate(104.991) scale(0.764652 2.25821)"
        >
          <stop offset="0.0833333" stopColor="#540F00" />
          <stop offset="0.823362" stopColor="#8E310F" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.6039 11.4006) rotate(75.0093) scale(0.764652 2.25821)"
        >
          <stop offset="0.0833333" stopColor="#540F00" />
          <stop offset="0.823362" stopColor="#8E310F" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.1987 5.67727) rotate(-117.874) scale(1.28649 2.0078)"
        >
          <stop stopColor="#A2411F" />
          <stop offset="0.829414" stopColor="#AB4B2B" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.02012 11.7339) rotate(-58.3245) scale(1.40072 2.07545)"
        >
          <stop stopColor="#7D280A" />
          <stop offset="1" stopColor="#9B3D15" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.8979 11.3375) rotate(-121.675) scale(1.40072 2.07545)"
        >
          <stop stopColor="#7D280A" />
          <stop offset="1" stopColor="#9B3D15" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.0229 5.34378) rotate(75.0093) scale(0.930256 2.74729)"
        >
          <stop offset="0.0833333" stopColor="#7E1700" />
          <stop offset="0.823362" stopColor="#8E310F" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0586 14.375) rotate(90) scale(2.89062 7.63672)"
        >
          <stop offset="0.249416" stopColor="#CE7B50" />
          <stop offset="0.577547" stopColor="#D28257" stopOpacity="0.37" />
          <stop offset="0.942137" stopColor="#912F09" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.44138 9.96185) rotate(95.39) scale(1.24696 2.70713)"
        >
          <stop stopColor="#FFD3B6" stopOpacity="0.3" />
          <stop offset="1" stopColor="#A45622" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_4706_230593"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.33661 6.17051) rotate(95.39) scale(0.759937 1.64981)"
        >
          <stop stopColor="#FFD3B6" stopOpacity="0.3" />
          <stop offset="1" stopColor="#A45622" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint12_linear_4706_230593"
          x1="7.81935"
          y1="8.12695"
          x2="7.81935"
          y2="11.5829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.790064" stopColor="#EEEEEE" />
          <stop offset="1" stopColor="#DCDCDC" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_4706_230593"
          x1="7.81935"
          y1="8.12695"
          x2="7.81935"
          y2="11.5829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#651901" />
          <stop offset="1" stopColor="#CD6A3A" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_4706_230593"
          x1="12.0596"
          y1="8.12695"
          x2="12.0596"
          y2="11.5829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.790064" stopColor="#EEEEEE" />
          <stop offset="1" stopColor="#DCDCDC" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_4706_230593"
          x1="12.0596"
          y1="8.12695"
          x2="12.0596"
          y2="11.5829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#651901" />
          <stop offset="1" stopColor="#CD6A3A" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_4706_230593"
          x1="10.071"
          y1="14.9538"
          x2="10.069"
          y2="12.3756"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#853209" />
          <stop offset="1" stopColor="#4B1300" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
